<template>
  <div class="content-view">
    <div class="all-read">
      <span @click="allReadClick"><i class="icon iconfont">&#xe638;</i>全部已读</span>
    </div>
    <div class="msg-contain">
      <el-table v-loading="loading" :row-class-name="tableRowClassName" :data="messageList"
        @selection-change="handleSelectionChange" @row-click="handleUpdate">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column label="消息内容" align="left">
          <template slot-scope="scope">
            <span>
              【设备{{scope.row.devId}}{{scope.row.attributeName}}传感器发生
              <el-tag type="danger">{{typeFormat(scope.row.type)}}</el-tag>
              预警,温度 {{numFilter(scope.row.reportValue)}}
              °c,{{abnormalFormat(scope.row)}}阈值{{scope.row.threshold}}°c】
            </span>
          </template>
        </el-table-column>
        <el-table-column label="站点名称" align="center" prop="siteName" width="200" />
        <el-table-column label="预警时间" align="center" prop="createTime" width="200" />
        <!-- <el-table-column
          label="操作"
          align="center"
          class-name="small-padding fixed-width"
          width="160"
        >
          <template slot-scope="scope">
            <el-button size="small" round @click="handleUpdate(scope.row)">查看预警日志</el-button>
          </template>
        </el-table-column> -->
      </el-table>

      <el-pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize"
        @pagination="getList" @current-change="handleCurrentChange" layout="total, prev, pager, next, jumper" />
    </div>
  </div>
</template>

<script>
import {
  listMessage,
  updateMessage,
  allReadyMessage
} from "@/api/analysis/message";
import store from "@/store";

export default {
  name: "Message",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 总条数
      total: 0,
      // ss表格数据
      messageList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        devId: undefined,
        siteId: undefined,
        param: undefined,
        type: undefined,
        reportValue: undefined,
        duration: undefined,
        threshold: undefined
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {}
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询ss列表 */
    getList() {
      this.loading = true;
      listMessage(this.queryParams).then(response => {
        this.messageList = response.rows;
        this.total = response.total;
        this.loading = false;
        // store.dispatch('GetMess');
      });
    },
    handleCurrentChange(val) {
      this.$set(this.queryParams, "pageNum", val);
      this.getList();
    },
    //未读row calss
    tableRowClassName({ row, rowIndex }) {
      if (row.status == 1) {
        return "row-read";
      }
    },
    //全部已读
    allReadClick() {
      if (store.getters.messCount <= 0) return;
      allReadyMessage().then(res => {
        if (res.code == 200) {
          store.commit("SET_MESS_COUNT", 0);
        }
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        delFlag: undefined,
        createBy: undefined,
        createTime: undefined,
        updateBy: undefined,
        updateTime: undefined,
        id: undefined,
        devId: undefined,
        siteId: undefined,
        param: undefined,
        type: undefined,
        reportValue: undefined,
        duration: undefined,
        threshold: undefined
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.single = selection.length != 1;
      this.multiple = !selection.length;
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加ss";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      if (row.status == 0) {
        row.status = 1;
        updateMessage(row).then(response => {
          if (response.code === 200) {
            // this.tableRowClassName(row)
            this.getList();
            let messCount = store.getters.messCount - 1;
            store.commit("SET_MESS_COUNT", messCount);
            // this.$router.push({
            //   name: "logs",
            //   query: {
            //     siteRow: row,
            //   },
            // });
          }
        });
      }
    },
    backTo() {
      this.$router.go(-1); //返回上一层
    },
    /** 提交按钮 */
    submitForm: function() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id != undefined) {
            updateMessage(this.form).then(response => {
              if (response.code === 200) {
                this.msgSuccess("修改成功");
                this.open = false;
                this.getList();
              }
            });
          } else {
            addMessage(this.form).then(response => {
              if (response.code === 200) {
                this.msgSuccess("新增成功");
                this.open = false;
                this.getList();
              }
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$confirm('是否确认删除ss编号为"' + ids + '"的数据项?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(function() {
          return delMessage(ids);
        })
        .then(() => {
          this.getList();
          this.msgSuccess("删除成功");
        })
        .catch(function() {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download(
        "system/message/export",
        {
          ...this.queryParams
        },
        `system_message.xlsx`
      );
    },
    numFilter(value) {
      const realVal = parseFloat(value).toFixed(2);
      return realVal;
    },
    typeFormat(row) {
      if (row == 1) {
        return "紧急";
      } else if (row == 2) {
        return "异常";
      } else if (row == 3) {
        return "异常";
      } else if (row == 4) {
        return "紧急";
      }
    },
    abnormalFormat(row) {
      if (row.type == 1) {
        return "低于紧急";
      } else if (row.type == 2) {
        return "超过异常";
      } else if (row.type == 3) {
        return "超过异常";
      } else if (row.type == 4) {
        return "超过紧急";
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.all-read {
  text-align: left;
  margin-bottom: 10px;
  cursor: pointer;
  .icon {
    font: 20px;
    color: #fff;
    margin-right: 5px;
  }
  span {
    font-size: 16px;
    color: #fff;
  }
}
.btn {
  margin-bottom: 20px;
}
.msg-contain {
  padding: 0px 0px 20px 0px;
  background-color: rgba(7, 31, 82, 0.2);
  border: 2px solid rgba(164, 196, 230, 0.2);
  height: 100%;
  box-sizing: border-box;
  padding: 20px;
  overflow: auto;
  .el-button {
    background: transparent;
    color: white;
  }
}
</style>
<style>
.el-table .row-read td .cell {
  color: #ccc !important;
  /* background: red; */
}
</style>
